export default {
  id: 'profile',
  routes: [
    { path: '/profile', title: 'My profile', breadcrumbs: ['My profile'], view: () => import('./views/profile.view.js') },
    { path: '/profile/security', title: 'Security', breadcrumbs: [{ label: 'My profile', href: '/profile' }, 'Security'], view: () => import('./views/security.view.js') },
  ],
};
